import React from 'react';

const Triangle = () => (
  <svg viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 10.5L0.75 20.4593V0.540708L18 10.5Z" fill="#D9D9D9" />
  </svg>
);

export default Triangle;
